import type { CSSProperties } from "react";
import type { RoundColor } from "../color";

export function ToonCard({ target, label }: { target: RoundColor; label: string }) {
  return (
    <div
      className={`toon-card ${target.shape}`}
      style={{ "--target": target.hex } as CSSProperties}
      aria-label={label}
    >
      <div className="toon-body">
        <span />
        <i />
        <b />
      </div>
      <em>{label}</em>
    </div>
  );
}
